import {Component, OnInit, ViewChild} from '@angular/core';
import {UserInfo} from '../shared/user-info.model';
import {DisplayMode} from '../../shared/display-mode';
import {UserService} from '../shared/user.service';
import {finalize} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {NavigationService} from '../../shared/services/navigation.service';
import {LoaderService} from '../../shared/services/loader.service';
import {ToastrService} from 'ngx-toastr';
import {UserFormComponent} from '../user-form/user-form.component';
import {ComponentCanDeactivate} from '../../core/guards/pending-changes.guard';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-chep-service-rep-form',
  templateUrl: './chep-service-rep-form.component.html',
  styleUrls: ['./chep-service-rep-form.component.scss']
})
export class ChepServiceRepFormComponent implements OnInit, ComponentCanDeactivate {
  user: UserInfo = new UserInfo();
  mode = DisplayMode.Creation;
  DisplayMode = DisplayMode;

  @ViewChild('userForm')
  userFormComponent: UserFormComponent;

  onCreate         = u => this.userService.createChepServiceRep(u);
  onUpdate         = u => this.userService.updateChepServiceRep(u);
  onDelete         = u => this.userService.deleteChepServiceRep(u.id);
  onToggleBlocking = u => this.userService.toggleBlockingChepServiceRep(u);
  onUnblockIp      = u => this.userService.unblockIpChepServiceRep(u);

  constructor(
    public userService: UserService,
    public navigationService: NavigationService,
    public loader: LoaderService,
    public toastr: ToastrService,
    public route: ActivatedRoute
) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const chepServiceRepId = params.id;

      if (!!chepServiceRepId) {
        this.loader.startLoad(false);

        this.userService.getById(chepServiceRepId)
          .pipe(finalize(() => this.loader.stopLoad()))
          .subscribe(chepServiceRep => {
            this.user = chepServiceRep;
            this.switchToUpdateMode();
          }, (error: HttpErrorResponse) => {
            console.log(error);
            this.toastr.error(`An error occured while fetching the chep service rep`, 'Error');
          });
      }
    });
  }

  getForm() {
    return this.userFormComponent.form;
  }

  goToChepServiceRepList() {
    this.navigationService
      .chepServiceRep()
      .list()
      .go();
  }

  changePassword(password: string) {
    this.loader.startLoad();
    this.userService.updatePassword(this.user, password)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(() => {
        this.toastr.success('The password has been successfully updated', 'Success');
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error(error.error.message || 'Error while updating the password', 'Error');
      });
  }

  private switchToUpdateMode() {
    this.mode      = DisplayMode.Edition;
  }
}
